import Vue from 'vue'
import VueI18n from 'vue-i18n'
import langs from './lang'
import hansLang from 'iview/src/locale/lang/zh-CN'
import enLang from 'iview/src/locale/lang/en-US'
import hantLang from 'iview/src/locale/lang/zh-TW'

const messages = {
  'zh-CN': hansLang ,
  'zh-TW': hantLang ,
  'en-US': enLang ,
}


Vue.use(VueI18n)

const navLang = navigator.language
const localLang = (navLang === 'zh-CN' || navLang === 'en-US') ? navLang : false
const locale = window.localStorage.lang || localLang || 'zh-CN'


for(let i in messages){
  Object.assign(langs[i], messages[i])
}

const i18n = new VueI18n({
  locale,
  messages:langs
})

export default i18n